'use client';
import { useFormik } from 'formik';
import { useState } from 'react';
import SectionLayout from 'layouts/SectionLayout';
import LoanCalculatorForm from './LoanCalculatorForm';
import LoanCalculatorEstimate from './LoanCalculatorEstimate';
import { LoanEstimateResponseTypes } from '.';
import { appAxios } from 'api/axios';
import { sendCatchFeedback, sendFeedback } from 'functions/feedback';
import { RoutePaths } from 'routes/route-paths';
import { useNavigate } from 'react-router-dom';
import MainLayout from 'layouts/MainLayout';
import {
  generateDurationOptions,
  LoanCalculatorFormValues,
  normalizeMoney,
  loanCalculatorvalidationSchema as validationSchema,
} from './utis';

const TransportLoanCalculator = () => {
  const [formData, setFormData] = useState({} as LoanCalculatorFormValues);
  const [loanEstimateData, setLoanEstimateData] = useState(
    {} as LoanEstimateResponseTypes
  );
  const navigate = useNavigate();
  const loanPeriod = 1;

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const submitLoanCalculator = async (values: LoanCalculatorFormValues) => {
    const baseUrl = window.location.origin;

    const postData = {
      salary: normalizeMoney(values.monthlyIncome),
      durationInMonths: values.durationInMonths,
      loanAmount: normalizeMoney(values.loanAmount),
      email: values.emailAddress,
      url: `${baseUrl}/transportation`,
    };
    try {
      const resp = await appAxios.post('/loan-calculator', postData);
      if (resp.status === 200) {
        setIsLoading(false);
        setLoanEstimateData(resp.data.data);
        sendFeedback(resp.data.message);
        setShowModal(true);
      }
    } catch (error) {
      setIsLoading(false);

      sendCatchFeedback(error);
      setIsLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      monthlyIncome: '',
      loanAmount: '',
      emailAddress: '',
      durationInMonths: '',
    },
    validationSchema,
    onSubmit: (values) => {
      setFormData(values);
      setIsLoading(true);
      submitLoanCalculator(values);
    },
  });
  const durationOptions = generateDurationOptions(2);
  return (
    <MainLayout>
      <SectionLayout>
        <section className="my-10 w-full max-w-2xl mx-auto">
          <article>
            <h2 className="text-[#212121] text-lg md:text-xl font-bold">
              Transport Credit
            </h2>
            <p className="text-[#616161] mt-2 md:text-lg leading-[140%]">
              Estimate loan for transportation
            </p>
          </article>

          <div className="p-2.5 w-full bg-[#EFA0051A] rounded-lg mt-6 text-sm flex items-center gap-4">
            <span className="size-6 flex items-center justify-center bg-[#EFA005] rounded-full text-white font-medium text-lg">
              !
            </span>
            <p className="#212121">
              This loan type offers a repayment duration of up to {loanPeriod}{' '}
              month
            </p>
          </div>

          <LoanCalculatorForm
            formik={formik}
            isLoading={isLoading}
            options={durationOptions}
          />
        </section>
        {showModal && (
          <LoanCalculatorEstimate
            onClose={() => setShowModal(false)}
            data={loanEstimateData}
            onApply={() => navigate(RoutePaths.TRANSPORT_GETSTARTED)}
            transport
            email={formData.emailAddress}
          />
        )}
      </SectionLayout>
    </MainLayout>
  );
};

export default TransportLoanCalculator;
